exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Spinner__container__V3gJd{display:-ms-flexbox;display:flex}.Spinner__hidden__1Jlt-{display:none}.Spinner__absolutelyCentered__3jxYJ{margin:auto;position:absolute;top:0;left:0;right:0;bottom:0;z-index:1003;background:#555}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/src/components/controls/Spinner.scss"],"names":[],"mappings":"AAAA,2BACE,oBAAa,AAAb,YAAa,CACd,AAED,wBACE,YAAa,CACd,AAED,oCACE,YAAY,AACZ,kBAAkB,AAClB,MAAM,AAAE,OAAO,AAAE,QAAQ,AAAE,SAAS,AACpC,aAAa,AACb,eAAgB,CACjB","file":"Spinner.scss","sourcesContent":[".container {\n  display: flex;\n}\n\n.hidden {\n  display: none;\n}\n\n.absolutelyCentered {\n  margin: auto;\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  z-index: 1003;\n  background: #555;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "Spinner__container__V3gJd",
	"hidden": "Spinner__hidden__1Jlt-",
	"absolutelyCentered": "Spinner__absolutelyCentered__3jxYJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/Spinner.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/Spinner.scss
// module chunks = 0